import { render, staticRenderFns } from "./TheBuildingSpaceAddForm.vue?vue&type=template&id=02f1f151&"
import script from "./TheBuildingSpaceAddForm.vue?vue&type=script&lang=js&"
export * from "./TheBuildingSpaceAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports